/**
 * Product Database can be added here.
 * You can add products of your wish with different attributes
 * */

export const products = [
  {
    _id: "ROGUNHRYMMD3M2A",
    title: "REAL MADRID JERSEY",
    description: "",
    price: 599,
    // discountPercentage: 12.9,
    rating: 4,

    images:
      "https://res.cloudinary.com/dqz5b6jq9/image/upload/v1690023023/Real_Madrid_Jersey_daqthi.webp",
    inStock: true,
    fastDelivery: true,
    categoryName: "Jersey",
    isFeatured: true,
  },
  {
    _id: "74CFP45BIEZAN1E",
    title: "TOTTENHAM HOTSPUR JERSEY",
    description: "",
    price: 499,
    // discountPercentage: 12.9,
    rating: 3,

    images:
      "https://res.cloudinary.com/dqz5b6jq9/image/upload/v1690023023/Totenhum_Jersey_nahhes.webp",
    inStock: true,
    fastDelivery: false,
    categoryName: "Jersey",
    isFeatured: false,
  },
  {
    _id: "AK7KADVMLGTR7M3",
    title: "BARCELONA JERSEY",
    description: "",
    price: 399,
    // discountPercentage: 12.9,
    rating: 3.5,

    images:
      "https://res.cloudinary.com/dqz5b6jq9/image/upload/v1690023023/Barcelona_Jersey_dnhx7l.webp",
    inStock: true,
    fastDelivery: true,
    categoryName: "Jersey",
    isFeatured: false,
  },

  {
    _id: "2ROGUNHRYMMD3M2",
    title: "MANCHESTER CITY JERSEY",
    description: "",
    price: 599,
    // discountPercentage: 12.9,
    rating: 3.9,

    images:
      "https://res.cloudinary.com/dqz5b6jq9/image/upload/v1690023340/Manchester_city_jersey_roqk5r.webp",
    inStock: false,
    fastDelivery: false,
    categoryName: "Jersey",
    isFeatured: false,
  },
  {
    _id: "KJMC7CXF5GJLFWH",
    title: "CHELSEA JERSEY",
    description: "",
    price: 299,
    // discountPercentage: 12.9,
    rating: 2.5,

    images:
      "https://res.cloudinary.com/dqz5b6jq9/image/upload/v1690023340/Chelsea_Jerse_sgiai1.webp",
    inStock: true,
    fastDelivery: true,
    categoryName: "Jersey",
    isFeatured: false,
  },
  {
    _id: "DST0G3NYLP281NJ",
    title: "JUVENTUS JERSEY",
    description: "",
    price: 299,
    // discountPercentage: 12.9,
    rating: 1.5,

    images:
      "https://res.cloudinary.com/dqz5b6jq9/image/upload/v1690023340/juventus_jersey_a6wxmo.webp",
    inStock: true,
    fastDelivery: true,
    categoryName: "Jersey",
    isFeatured: false,
  },

  {
    _id: "YBJB95IGVKRWT1D",
    title: "A.C. MILAN JERSEY",
    description: "",
    price: 349,
    // discountPercentage: 12.9,
    rating: 2.5,
    images:
      "https://res.cloudinary.com/dqz5b6jq9/image/upload/v1690023573/a.c_milan_jersey_pgz3lj.webp",
    inStock: true,
    fastDelivery: false,
    categoryName: "Jersey",
    isFeatured: false,
  },
  {
    _id: "JC6FMBA12KQZIWI",
    title: "INTER MILAN JERSEY",
    description: "",
    price: 249,
    // discountPercentage: 12.9,
    rating: 3,

    images:
      "https://res.cloudinary.com/dqz5b6jq9/image/upload/v1690023573/Inter_Milan_Jersey_yakwad.webp",
    inStock: false,
    fastDelivery: true,
    categoryName: "Jersey",
    isFeatured: false,
  },
  {
    _id: "5AL43F8A4L5QPC5",
    title: "FC BAYERN MUNICH JERSEY",
    description: "",
    price: 349,
    // discountPercentage: 12.9,
    rating: 4,

    images:
      "https://res.cloudinary.com/dqz5b6jq9/image/upload/v1690023573/Bayern_Munich_Jersey_lr553o.webp",
    inStock: true,
    fastDelivery: true,
    categoryName: "Jersey",
    isFeatured: false,
  },
  {
    _id: "51MN9ERXPB887B0",
    title: "BORUSSIA DORTMUND JERSEY",
    description: "",
    price: 299,
    // discountPercentage: 12.9,
    rating: 4.2,

    images:
      "https://res.cloudinary.com/dqz5b6jq9/image/upload/v1690024146/boursia_jersey_r5d9o7.webp",
    inStock: false,
    fastDelivery: true,
    categoryName: "Jersey",
    isFeatured: false,
  },
  {
    _id: "51MN9ERXEB887B0",
    title: "MANCHESTER UNITED JERSEY",
    description: "",
    price: 349,
    // discountPercentage: 12.9,
    rating: 4,

    images:
      "https://res.cloudinary.com/dqz5b6jq9/image/upload/v1690025417/man_u_jersey_nw0jgg.jpg",
    inStock: false,
    fastDelivery: true,
    categoryName: "Jersey",
    isFeatured: false,
  },
  {
    _id: "73G4K9GKHQ1CHIO",
    title: "REAL MADRID SHORTS",
    description: "",
    price: 399,
    // discountPercentage: 12.9,
    rating: 3,
    images:
      "https://res.cloudinary.com/dqz5b6jq9/image/upload/v1690024145/real-madrid-21-22-home-shorts_iiqnqr.jpg",
    inStock: true,
    fastDelivery: false,
    categoryName: "Shorts",
    isFeatured: true,
  },
  {
    _id: "BZ8QQ9FO7L6NZH0",
    title: "BORUSSIA DORTMUND SHORTS",
    description: "",
    price: 249,
    // discountPercentage: 12.9,
    rating: 3,
    images:
      "https://res.cloudinary.com/dqz5b6jq9/image/upload/v1690024145/boursia_dortmound_shorts_mphscy.jpg",
    inStock: true,
    fastDelivery: true,
    categoryName: "Shorts",
    isFeatured: false,
  },

  {
    _id: "S3682JUPE13H14D",
    title: "JUVENTUS SHORTS",
    description: "",
    price: 199,
    // discountPercentage: 12.9,
    rating: 3,
    images:
      "https://res.cloudinary.com/dqz5b6jq9/image/upload/v1690024145/Juv_Shorts_a8qg7z.jpg",
    inStock: true,
    fastDelivery: true,
    categoryName: "Shorts",
    isFeatured: false,
  },
  {
    _id: "YCGLE06759PUZKT",
    title: "BARCELONA SHORTS",
    description: "",
    price: 149,
    // discountPercentage: 12.9,
    rating: 3,
    images:
      "https://res.cloudinary.com/dqz5b6jq9/image/upload/v1690024640/barcelona_jersey_z3gdoq.webp",
    inStock: false,
    fastDelivery: true,
    categoryName: "Shorts",
    isFeatured: false,
  },
  {
    _id: "IXE96EQ0F6DTQAB",
    title: "MANCHESTER CITY SHORTS",
    description: "",
    price: 99,
    // discountPercentage: 12.9,
    rating: 2,
    images:
      "https://res.cloudinary.com/dqz5b6jq9/image/upload/v1690024640/Manc_jersey_a1tx6i.jpg",
    fastDelivery: true,
    categoryName: "Shorts",
    isFeatured: false,
  },
  {
    _id: "IXE96EQ0F6DTQWX",
    title: "MANCHESTER UNITED SHORTS",
    description: "",
    price: 199,
    // discountPercentage: 12.9,
    rating: 3,
    images:
      "https://res.cloudinary.com/dqz5b6jq9/image/upload/v1690025416/man_u_shorts_ae5vrj.jpg",
    fastDelivery: true,
    categoryName: "Shorts",
    isFeatured: false,
  },
  {
    _id: "IXE78EQ0F6DTQWX",
    title: "INTER MILAN SHORTS",
    description: "",
    price: 249,
    // discountPercentage: 12.9,
    rating: 3.5,
    images:
      "https://res.cloudinary.com/dqz5b6jq9/image/upload/v1690025416/inter_milan_shorts_xttfmv.jpg",
    fastDelivery: true,
    categoryName: "Shorts",
    isFeatured: false,
  },
  {
    _id: "FYDCWJVLO6OWS42",
    title: "JUVENTUS FOOTBALL",
    description: "",
    price: 299,
    // discountPercentage: 12.9,
    rating: 3,
    images:
      "https://res.cloudinary.com/dqz5b6jq9/image/upload/v1690024640/Juventus_football_owtsjp.jpg",
    inStock: true,
    fastDelivery: false,
    categoryName: "Football",
    isFeatured: false,
  },

  {
    _id: "R8ID2QR6PS29OXO",
    title: "REAL MADRID FOOTBALL",
    description: "",
    price: 399,
    // discountPercentage: 12.9,
    rating: 4,
    images:
      "https://res.cloudinary.com/dqz5b6jq9/image/upload/v1690024640/RM_ball_sn1g8z.jpg",
    inStock: true,
    fastDelivery: true,
    categoryName: "Football",
    isFeatured: false,
  },
  {
    _id: "3PVVUXNIN8HHSUW",
    title: "MANCHESTER CITY FOOTBALL",
    description: "",
    price: 299,
    // discountPercentage: 12.9,
    rating: 3,
    images:
      "https://res.cloudinary.com/dqz5b6jq9/image/upload/v1690024641/man_c_football_kl0du9.png",
    inStock: false,
    fastDelivery: false,
    categoryName: "Football",
    isFeatured: false,
  },
  {
    _id: "4CFP45BIEZAN1EA",
    title: "FC BAYERN MUNICH FOOTBALL",
    description: "",
    price: 99,
    // discountPercentage: 12.9,
    rating: 2,
    images:
      "https://res.cloudinary.com/dqz5b6jq9/image/upload/v1690024989/bayern_munich_wg4e5z.jpg",
    inStock: true,
    fastDelivery: true,
    categoryName: "Football",
    isFeatured: true,
  },
  {
    _id: "K7KADVMLGTR7M37",
    title: "BARCELONA FOOTBALL",
    description: "",
    price: 199,
    // discountPercentage: 12.9,
    rating: 3,
    images:
      "https://res.cloudinary.com/dqz5b6jq9/image/upload/v1690024989/barcelona_gtus8s.webp",
    inStock: true,
    fastDelivery: false,
    categoryName: "Football",
    isFeatured: false,
  },
  {
    _id: "K7KADVXYGTR7M37",
    title: "MANCHESTER UNITED FOOTBALL",
    description: "",
    price: 149,
    // discountPercentage: 12.9,
    rating: 3.3,
    images:
      "https://res.cloudinary.com/dqz5b6jq9/image/upload/v1690025417/man_u_ball_tes1lo.jpg",
    inStock: true,
    fastDelivery: false,
    categoryName: "Football",
    isFeatured: false,
  },
];
